import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import {readTracking} from '../../redux/actions/Tracking/TrackingAction';
function ViewTracking({readTracking,trackings}) {
    const[tracking,setTracking]=useState({});
    const param=useParams();
    useEffect(() => {
        console.log('trackings',trackings);
        if (trackings && trackings.length==0)
            readTracking().catch((error) => {
                alert('Loading failed ' + error);
            });
    }, [trackings]);
    useEffect(()=>{
        console.log(trackings);
        const data=trackings && trackings.filter((tracking)=>tracking.customer.customerId==param.id);
        console.log(data);
        setTracking(data[0]);
        console.log(tracking);
    },[trackings]);
    console.log(tracking);
    return (
        <>
            <div className="container-fluid product-details-page">
                <h4 className="text-center py-2 product-header">Product Details</h4>
                <div className="row">
                    <div className="col-md-6 p-5 mx-auto shadow product-details">
                        <h5><span className='detail'>Tracking ID:</span> {tracking && tracking.trackingId}</h5>
                        <h5><span className='detail'>First Name:</span> {tracking && tracking.customer && tracking.customer.firstName}</h5>
                        <h5><span className='detail'>Last Name:</span> {tracking && tracking.customer && tracking.customer.lastName}</h5>
                        <h5><span className='detail'>Status:</span> {tracking && tracking.status}</h5>
                    
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        trackings: state.trackings,
    };
};
const mapDispatchToProps={
    readTracking,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewTracking);